import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import type { Course, TableOfContent } from '@openclassrooms/sdk-web';
import { translate } from '@openclassrooms/translations';
import { QuizLearningStatus } from './LearningStatus';
import useQuizLearningStatus from '../../_hooks/useQuizLearningStatus';
import TocItemWrapper from './TocItemWrapper';
export interface Props {
  categoryColor: string;
  quizPart: TableOfContent;
  isOnHomePage: boolean;
  course: Course;
  onClick?: () => void;
}
const QuizTocItem = t0 => {
  const $ = _c(18);
  const {
    categoryColor,
    quizPart,
    isOnHomePage,
    course,
    onClick: t1
  } = t0;
  const onClick = t1 === undefined ? _temp : t1;
  const {
    id,
    title,
    learningActivityStatus
  } = quizPart;
  const params = useParams();
  let t2;
  if ($[0] !== params) {
    t2 = params || {};
    $[0] = params;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    exerciseId
  } = t2;
  const {
    userIsFollowingCourse: isFollowingCourse
  } = course;
  let t3;
  if ($[2] !== isFollowingCourse || $[3] !== isOnHomePage || $[4] !== learningActivityStatus) {
    t3 = {
      initialStatus: learningActivityStatus,
      isOnHomePage,
      userIsFollowingCourse: isFollowingCourse
    };
    $[2] = isFollowingCourse;
    $[3] = isOnHomePage;
    $[4] = learningActivityStatus;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    status: quizLearningStatus
  } = useQuizLearningStatus(t3);
  const isCurrentlyDisplayed = id === Number(exerciseId);
  let t4;
  if ($[6] !== categoryColor || $[7] !== quizLearningStatus) {
    t4 = <QuizLearningStatus status={quizLearningStatus} color={categoryColor} />;
    $[6] = categoryColor;
    $[7] = quizLearningStatus;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const Icon = t4;
  let t5;
  if ($[9] !== title) {
    t5 = translate("course_toc.quiz.label", {
      label: title
    });
    $[9] = title;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== Icon || $[12] !== course || $[13] !== isCurrentlyDisplayed || $[14] !== onClick || $[15] !== quizPart || $[16] !== t5) {
    t6 = <TocItemWrapper isCurrentlyDisplayed={isCurrentlyDisplayed} part={quizPart} label={t5} course={course} shouldPrefetch={false} onClick={onClick} learningStatusIcon={Icon} />;
    $[11] = Icon;
    $[12] = course;
    $[13] = isCurrentlyDisplayed;
    $[14] = onClick;
    $[15] = quizPart;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default QuizTocItem;
function _temp() {}